import Brand from '@/page/archives/goods/Brand';
import Supplier from '@/page/archives/goods/Supplier';
import Detail from '@/components/template/detail'
import Set from '@/page/archives/goods/Set';
import Info from '@/page/archives/goods/Info';
import Recycle from '@/page/archives/goods/Recycle';
import QInfo from '@/page/archives/query/Info';
import Dadjap from '@/page/archives/query/Dadjap';
import PDadjap from '@/page/archives/price/Dadjap';
import DadjapAdd from '@/page/archives/price/DadjapAdd';
import Category from '@/page/archives/goods/Category';
import Rule from '@/page/archives/goods/Rule';
import Unit from '@/page/archives/goods/Unit';
import Scales from '@/page/archives/goods/Scales';
import Mgmt from '@/page/archives/goods/store/Mgmt';
import Combination from '@/page/archives/goods/Combination';
import BarCodeManage from '@/page/archives/goods/BarCodeManage';
// import detail from '@/components/template/detail';
import pdadjapDetail from '@/page/archives/price/DadjapDetail';
import Recipe from '@/page/archives/goods/Recipe';

export const archives = [{
  path: '/archives/goods/rule',
  name: 'rule',
  component: Rule,
  meta: {
    requireAuth: true,
    title: '商品规格'
  }
}, {
  path: '/archives/goods/brand',
  name: 'brand',
  component: Brand,
  meta: {
    requireAuth: true,
    title: '商品品牌'
  }
},
  {
    path: '/archives/goods/unit',
    name: 'unit',
    component: Unit,
    meta: {
      requireAuth: true,
      title: '商品单位'
    }
  },
  {
    path: '/archives/goods/brand/detail',
    name: 'brandDetail',
    component: Detail,
    meta: {
      requireAuth: true,
      title: '商品品牌'
    }
  },
  {
    path: 'archives/goods/category',
    name: 'Category',
    component: Category,
    meta: {
      requireAuth: true,
      title: '商品类别'
    }
  },
  {
    path: '/archives/goods/supplier',
    name: 'supplier',
    component: Supplier,
    meta: {
      requireAuth: true,
      title: '供应商'
    }
  },
  {
    path: '/archives/goods/supplier/detail',
    name: 'supplierDetail',
    component: Detail,
    meta: {
      requireAuth: true,
      title: '供应商'
    }
  },
  {
    path: '/archives/goods/set',
    name: 'set',
    component: Set,
    meta: {
      requireAuth: true,
      title: '商品业务规则设置'
    }
  },
  {
    path: '/archives/goods/info',
    name: 'goodsInfo',
    component: Info,
    meta: {
      requireAuth: true,
      title: '商品档案'
    }
  },
  {
    path: '/archives/goods/recipe',
    name: 'goodsRecipe',
    component: Recipe,
    meta: {
      requireAuth: true,
      title: '商品做法'
    }
  },
  {
    path: '/archives/query/info',
    name: 'qInfo',
    component: QInfo,
    meta: {
      requireAuth: true,
      title: '商品档案综合查询'
    }
  },
  {
    path: '/archives/query/dadjap',
    name: 'dadjap',
    component: Dadjap,
    meta: {
      requireAuth: true,
      title: '商品调价查询'
    }
  },
  {
    path: '/archives/price/dadjap',
    name: 'pdadjap',
    component: PDadjap,
    meta: {
      requireAuth: true,
      title: '调价单'
    }
  },
  {
    path: '/archives/price/dadjap/detail',
    name: 'pdadjapDetail',
    component: pdadjapDetail,
    meta: {
      requireAuth: true,
      title: '调价单'
    }
  },
  {
    path: '/archives/price/dadjap/add',
    name: 'dadjapAdd',
    component: DadjapAdd,
    meta: {
      requireAuth: true,
      title: '调价单'
    }
  },
  {
    path: '/archives/goods/recycle',
    name: 'recycle',
    component: Recycle,
    meta: {
      requireAuth: true,
      title: '商品回收站'
    }
  },
  {
    path: '/archives/goods/scales',
    name: 'scales',
    component: Scales,
    meta: {
      requireAuth: true,
      title: '传称商品'
    }
  },
  {
    path: '/archives/goods/store/mgmt',
    name: 'mgmt',
    component: Mgmt,
    meta: {
      requireAuth: true,
      title: '门店商品管理'
    }
  },
  {
    path: '/archives/goods/Combination',
    // path: '/archives/goods/BarCodeManage',
    name: 'combination',
    component: Combination,
    meta: {
      requireAuth: true,
      title: '商品组合'
    }
  },
  {
    path: '/archives/goods/barcode',
    name: 'barCodeManage',
    component: BarCodeManage,
    meta: {
      requireAuth: true,
      title: '一品多码'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/archives.route.js